import PropTypes from 'prop-types';
import React from 'react';
import { Card, CardBody } from 'reactstrap';

// Metric card component
const MetricCard = _ref => {
  let title = _ref.title,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? null : _ref$subtitle,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? null : _ref$color;
  return /*#__PURE__*/React.createElement(Card, {
    className: "h-100 border-0 shadow-sm"
  }, /*#__PURE__*/React.createElement(CardBody, {
    className: "text-center py-2 px-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-muted small mb-1"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "h2 mb-0 ".concat(color ? "text-".concat(color) : '')
  }, value !== null && value !== void 0 ? value : '—'), subtitle && /*#__PURE__*/React.createElement("div", {
    className: "text-muted small mt-1"
  }, subtitle)));
};
MetricCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  subtitle: PropTypes.string,
  color: PropTypes.string
};

// Removed defaultProps - using default parameters in function signature instead

export default MetricCard;